import { Component, inject, Input, OnInit } from '@angular/core';
import { AssignmentScheduleListModel } from '../../models/assignment-schedule-list.model';
import { Router } from '@angular/router';

@Component({
    selector: 'app-assignment-schedules-list',
    templateUrl: './assignment-schedules-list.component.html',
    styleUrl: './assignment-schedules-list.component.scss'
})
export class AssignmentSchedulesListComponent implements OnInit {
    @Input({ required: true }) public assignmentSchedules!: AssignmentScheduleListModel[];


    private router = inject(Router);

    constructor() { }

    ngOnInit(): void {
    }


    protected routeToAssignment(assignmentScheduleId: string): void {
        this.router.navigate(['/assignments', 'schedules', assignmentScheduleId]);
    }

}
